<template>
  <div class="work">
    <el-row :gutter="20">
      <el-col :span="6" v-for="(item, index) in menuList" :key="index">
        <div class="grid-content" :style="{ backgroundColor: item.backgroundColor }" @click="toJump(item)">
          <div>
            <img :src="item.img">
            <span class="">{{ item.text }}</span>
          </div>
          <el-badge :value="0" :hidden="item.isHidden"></el-badge>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    menuList: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    toJump (args) {
      this.$emit('toJumps', args)
      // top.addPanelwithTab(text, path)
    }
  }
};
</script>

<style lang="less" scoped>
.work {
  height: calc(100% - 15px);
  margin-top: 15px;
  overflow-y: auto;
  overflow-x: hidden;
  .el-row {
    .el-col {
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .grid-content {
      box-shadow: 0px 0px 15px 0px 
      rgba(72, 0, 255, 0.2);
      border-radius: 16px;
      position: relative;
      max-width: 266px;
      font-size: calc(0.964vw);
      cursor: pointer;
      color: #fff;
      &::after {
        content: '';
        display: block;
        padding-bottom: 70%;
      }
      & > div:not(.el-badge) {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
      }
      img {
        width: 40%;
      }
      .el-badge {
        position: absolute;
        right: 0;
        top: 0;
        transform: translateY(-50%);
        z-index: 100;
      }
    }
  }
}
</style>